(function () {
  const MOBILE_MQ = window.matchMedia('(max-width: 430px)');

  const SELECTORS = {
    section: '[data-hc-air-dry-clay]',
    item: '[data-hc-air-dry-clay-item]',
  };

  const OPEN_THRESHOLD = 0.5;
  const CLOSE_DISTANCE = 153;

  const instances = new Map();

  function openItem(item) {
    item.classList.add('is-active');
  }

  function closeItem(item) {
    item.classList.remove('is-active');
  }

  function scrollToItem(item) {
    item.scrollIntoView({
      inline: 'start',
      block: 'center',
      behavior: 'smooth',
    });
  }

  function createInstance(section) {
    if (instances.has(section)) return;

    const items = Array.from(section.querySelectorAll(SELECTORS.item));
    if (!items.length) return;

    function onScroll() {
      if (!MOBILE_MQ.matches) {
        items.forEach(closeItem);
        return;
      }

      const viewportHeight = window.innerHeight;
      const openLine = viewportHeight * OPEN_THRESHOLD;

      items.forEach((item) => {
        const rect = item.getBoundingClientRect();

        const shouldOpen =
          rect.top <= openLine &&
          rect.bottom >= openLine - CLOSE_DISTANCE;

        if (shouldOpen) {
          openItem(item);
        } else {
          closeItem(item);
        }
      });
    }

    function onClick(event) {
      const item = event.currentTarget;

      if (MOBILE_MQ.matches) {
        scrollToItem(item);
        return;
      }

      scrollToItem(item);
    }

    items.forEach((item) => {
      item.addEventListener('click', onClick);
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);

    instances.set(section, {
      destroy() {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);

        items.forEach((item) => {
          item.removeEventListener('click', onClick);
          closeItem(item);
        });
      },
      refresh: onScroll,
    });

    onScroll();
  }

  function destroyInstance(section) {
    const instance = instances.get(section);
    if (!instance) return;

    instance.destroy();
    instances.delete(section);
  }

  function init() {
    const sections = Array.from(document.querySelectorAll(SELECTORS.section));

    sections.forEach((section) => {
      createInstance(section);
    });

    instances.forEach((instance, section) => {
      if (!document.body.contains(section)) {
        destroyInstance(section);
      } else {
        instance.refresh();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', init);

  MOBILE_MQ.addEventListener('change', () => {
    instances.forEach((instance) => instance.refresh());
  });

  document.addEventListener('shopify:section:load', init);

  document.addEventListener('shopify:section:unload', function (event) {
    const section = event.target.querySelector(SELECTORS.section);

    if (section) {
      destroyInstance(section);
    }
  });
})();
